<template>
    <Flicking
        ref="flickingRef"
        :options="carouselOptions"
        :plugins="carouselPlugins"
    >
        <div
            class="panel pt-5 pb-4"
            v-for="(panel, panelIdx) in panels"
            :key="panelIdx"
            @click="onPanelClick($event, panelIdx, panel)"
        >
            <div :class="{ 'panel-content': borders }" class="pb-2 text-center">
                <slot name="panel" :idx="panelIdx" :panel="panel"></slot>
            </div>
        </div>

        <template #viewport v-if="panels.length > 1">
            <div class="flicking-pagination"></div>
            <span class="flicking-arrow-prev is-circle"></span>
            <span class="flicking-arrow-next is-circle"></span>
        </template>
    </Flicking>
</template>

<style lang="scss" scoped>
.panel {
    width: 75%;
    @media (min-width: 798px) {
        width: 40%;
    }
}

.panel-content {
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-radius: 20px;
}

.flicking-pagination {
    top: 10px;
    bottom: unset;
}

.flicking-arrow-prev,
.flicking-arrow-next {
    zoom: 68%;
    @media (min-width: 798px) {
        zoom: unset;
    }
}
</style>

<script setup lang="ts">
import { ref, toRefs } from "vue";
import { EVENTS } from "@egjs/flicking";
import { Fade, Arrow, Pagination } from "@egjs/flicking-plugins";
import Tuck from "./_plugins/tuck.js";

const props = defineProps({
    panels: { type: Array, default: () => [] },
    capturePanelClicks: { type: Boolean, default: true },
    borders: { type: Boolean, default: true },
});
const { panels, capturePanelClicks, borders } = toRefs(props);
const emit = defineEmits(["panelClick"]);
const flickingRef = ref<any>(null);
const carouselOptions = ref({ camera: "0%", panel: "75%", moveType: "strict", resizeOnContentsReady: true });
const carouselPlugins = ref([
    new Fade("", 0.7),
    new Tuck({ tuck: 200, scale: 0.5, perspective: 100 }),
].concat(panels.value.length > 1 ? [new Arrow(), new Pagination({ type: "bullet" })] : []));

async function onPanelClick(event, idx, panel) {
    const flicking = flickingRef.value;
    if (flicking.index == idx) {
        if (capturePanelClicks.value) {
            event.preventDefault();
            emit("panelClick", { idx, panel });
        }
        return;
    }
    event.preventDefault();
    flicking.interruptable = false;
    flicking.once(EVENTS.MOVE_END, () => { flicking.interruptable = true; });
    await flicking.moveTo(idx);
}
</script>
